module.exports = __webpack_public_path__ + "static/media/pr1.93d86a7d.jpg";